import React from "react";
import { Box, Typography } from "@mui/material";
import "../../styles/components-styles/Classroom.css";
import classroom1 from "../img/Classroom1.png";
import classroom2 from "../img/Classroom2.png";
import classroom3 from "../img/Classroom3.png";
function Classroom() {
  const ClassCard = ({ img }) => (
    <Box className="img-box-classroom">
      <img src={img} alt="" />
    </Box>
  );

  return (
    <Box className="classroom-container">
      <Box className="classroom-title-container">
        <Typography className="classroom-title">Classroom</Typography>
      </Box>
      <Box className="classroom-box">
        <ClassCard img={classroom1} />
        <ClassCard img={classroom2} />
        <ClassCard img={classroom3} />
      </Box>
    </Box>
  );
}

export default Classroom;
